export default {

    toStringDate(date = null){
        if(date) {
            return new Date(date+'T00:00:00');
        }
        return undefined;
    }

}